import { CmmResponseStatus } from "../../../../enums/cmmResponseStatus";
import { CmmStpStatus } from "../../../../enums/cmmStpStatus";
import { PaStatus } from "../../../../enums/paStatus";

export const allResponseStatusOptions = [
  { label: "Approved", value: CmmResponseStatus.APPROVED },
  { label: "Approval on File", value: CmmStpStatus.APPROVAL_ON_FILE },
  { label: "Auth Not Required", value: CmmResponseStatus.AUTH_NOT_REQUIRED },
  { label: "Denied", value: CmmResponseStatus.DENIED },
  { label: "Denial on File", value: CmmStpStatus.DENIAL_ON_FILE },
  { label: "Drug Not Covered", value: CmmResponseStatus.DRUG_NOT_COVERED },
  { label: "Pending", value: CmmResponseStatus.PENDING },
  { label: "Appeal Pending", value: PaStatus.APPEAL_PENDING },
  { label: "NA Outcome", value: CmmResponseStatus.NA_OUTCOME },
  { label: "PA Resolved", value: CmmStpStatus.PA_RESOLVED },
  { label: "Non-ePA", value: CmmStpStatus.NON_EPA },
  { label: "Case on File", value: CmmStpStatus.CASE_ON_FILE },
  {
    label: "Not Correct Processor",
    value: CmmResponseStatus.NOT_CORRECT_PROCESSOR,
  },
  { label: "Other Platforms", value: CmmStpStatus.OTHER_PLATFORMS },
  { label: "Onshore Assistance", value: CmmResponseStatus.ONSHORE_ASSISTANCE },
  { label: "Send To Client", value: CmmResponseStatus.SEND_TO_CLIENT },
];
